var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-0",attrs:{"slot":"activator","icon":"","disabled":_vm.disabled,"width":_vm.width},on:{"click":_vm.showImageDialog},slot:"activator"},[_c('v-icon',[_vm._v("mdi-publish")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }